import { Id } from '@/infra/id'
import { unixEpoch } from '@/utils/date-util'
import { action, observable } from 'mobx'
import { Model, type ModelProps } from '@/infra/model'
import { collection } from '@/infra/collection'
import {
  BillingMethod,
  type BillingMethodProps,
} from '@/features/billing/profile/BillingMethod'

export type BillingProfileProps = ModelProps<BillingProfile> & {
  billingMethods?: BillingMethodProps[]
}

export class BillingProfile extends Model<BillingProfile> {
  static readonly none = new BillingProfile()

  id = Id.none
  userId: Id = Id.none
  workspaceId: Id = Id.none
  teamId: Id = Id.none

  @observable accessor referralCouponCode = ''
  @observable accessor referralCouponId = Id.none
  @observable accessor dateCreated = unixEpoch()
  @observable accessor dateModified = unixEpoch()
  @observable accessor defaultBillingMethodId = Id.none

  readonly billingMethods = collection({
    getModelId: (m) => m.id,
    getDataId: (d) => d.id,
    create: () => new BillingMethod(this),
  })

  /** @inheritDoc */
  @action.bound
  override set({
    billingMethods,
    ...rest
  }: Partial<BillingProfileProps>): this {
    if (billingMethods) {
      this.billingMethods.reset(billingMethods)
    }
    return super.set(rest)
  }
}
